import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

export interface IPayload {
    name: string;
    email: string;
    phone?: string;
    address?: string;
}

interface IProps {
    customerId: string;
    recipientId: string;
    payload: IPayload;
}

export const useUpdateRecipientMutation = ({ customerId, payload, recipientId }: IProps) => useMutation(
  'useUpdateRecipientMutation',
  async () => {
    const res = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/recipient/${recipientId}`, { ...payload });
    return res.data;
  },
  { retry: 1 },
);
